'use strict';

const getCountryFromLocaleCookie = require('./getCountryFromLocaleCookie');

const fillAddressFields = (address, $form) => {
    for (const field in address) {
        if (field === 'ID' || field === 'UUID' || field === 'key') {
            continue;
        }
        // if the key in address object ends with 'Code', remove that suffix
        // keys that ends with 'Code' are postalCode, stateCode and countryCode
        const $field = $form.find('[name$="' + field.replace('Code', '') + '"]');
        $field .val(address[field]);
        // update the state fields
        if (field === 'countryCode') {
            handleCountryCodeChange($field, $form, address.stateCode);
        }

        if (field === 'postalCode') {
            hanldePostalCodeChange($field);
        }
    }
};

const handleCountryCodeChange = ($field, $form, stateCode) => {
    $field.trigger('change');
    // retrigger state selection after country has changed
    // this results in duplication of the state code, but is a necessary evil
    // for now because sometimes countryCode comes after stateCode
    $form.find('[name$="state"]').val(stateCode);
    if (getCountryFromLocaleCookie() === 'US') {
        const $stateSelect = $form.find('[name$="stateUS"]');
        $stateSelect.val(stateCode);
        $stateSelect.selectric('refresh');
    }
};

const hanldePostalCodeChange = ($field) => {
    if (getCountryFromLocaleCookie() === 'US') {
        $field.trigger('blur');
    }
};

module.exports = fillAddressFields;
